import React, { useState,useEffect } from 'react';
import Tab from '../components/tab';
import 'react-quill/dist/quill.snow.css';
import TextEditor from "../components/TextArea";
import { Typewriter } from "react-simple-typewriter";
import { motion } from "framer-motion";
import MicIcon from "@mui/icons-material/Mic";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { 
  dispatchActivites, 
  generate_experience, 
  cleanEX,
  returnHome, 
  currentExperience,
} from "../../../Redux/ActionCreator";
import {
  Deepseek_generate_experience
} from "../../../Redux/DeepseekAI/index.js"
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import { getOneFromServerCache, saveIntoServerCache } from "../../../utils/saveIntoCache";
import { capitalize } from "../../../utils/capitalize/capitalizeWord";
import LoaderModal from "../../common/LoaderModal/index.jsx";
import { extractLatestThreeExperiences } from '../../../utils/skillsService/index.js';


export default function Experience5({ nextStep, prevStep }) {

  const profile = useSelector(e => e.profile);
  const dispatch = useDispatch();
  
  const exp = useSelector(exp => exp.activities);
  const currentExp = useSelector(exp => exp.currentExperience);
  const secret = useSelector(prev => prev.secret);
  const existing_cv_data = useSelector((prev) => prev.existingCV);
  const message = existing_cv_data.message;
  const profile1 = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  let Tags = useSelector(e => e.tags);
  const expText = useSelector(ai => ai.exp);
  const current_skills = useSelector(e => e.current_skills);
  let [ generate, setGenerate ] = useState(false);
  let [ generatePrev, setPrevGenerate ] = useState(false);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const [companyName, setCompanyName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [error, setError] = useState('');
  let [ experience, setExperience ] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [truty, setTruty] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const handleNext = () => {
    if (!companyName || !jobTitle) {
      setError('Please fill in all fields before continuing');
      return;
    }
    setError('');
    nextStep();
  };

  // Function to strip HTML tags
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || ""; // Extract plain text
  };

  useEffect(() => {
    if (currentExp.message?.Day_to_day_work !== null) {
      console.log("Prefilling experience from Redux:", currentExp.message?.Day_to_day_work);
      // Set cleaned experience
      if (currentExp.message?.Day_to_day_work !== null && currentExp.message?.Day_to_day_work !== undefined) {
        localStorage.setItem("fClicked", true);
      }
      let experienceText = Array.isArray(currentExp.message?.Day_to_day_work) ? currentExp.message?.Day_to_day_work?.join("\n") : currentExp.message?.Day_to_day_work;
      setExperience(experienceText);
      setGenerate(true);
    } else {
      let cacheInfo = getOneFromServerCache("current_experience")
      cacheInfo.then(res => res.json())
      .then(res => {
        // console.log("server cache value", res);
        if (res.success === true) {
          if (res.data !== null && res.data !== undefined) {
            let resObj = JSON.parse(res.data);
            // console.log("respObj", resObj);
            dispatch(currentExperience(resObj));
            let experienceText = Array.isArray(resObj?.Day_to_day_work) ? resObj?.Day_to_day_work?.join("\n") : resObj?.Day_to_day_work;
            setExperience(experienceText);
          }
          // console.log("Done");
        } else if (res.success === false && res.message == "Unauthorized") {
          dispatch(returnHome(res.status));
        }
      }).catch (error => console.log("Error prefilling the current experience company name and title", error))
    }

  }, []);
  const [ eventCount, setEventCount ] = useState(0);
  useEffect(() => {
    if (expText.exp !== null) {
      setGenerate(true);
      localStorage.setItem("fClicked", true);
      setEventCount(0);
      setPrevGenerate(false);
      let experience = expText.exp?.replace(/\n/g, "<br>")
      setExperience(experience);
      let current_Exp_To_Be_Saved = { ...currentExp.message, Day_to_day_work: experience || null, Tags: Tags?.message, Skills: current_skills?.skills }
      dispatch(currentExperience(current_Exp_To_Be_Saved));
      saveIntoServerCache("current_experience", current_Exp_To_Be_Saved);
      setLoading(false);
    }
  }, [expText]);

  console.log("eventCount", eventCount);

  const [showExperience, setShowExperience] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showExperienceTimeout = setTimeout(() => setShowExperience(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(showExperienceTimeout);
  }, []);

  useEffect(() => {
    if (showExperience == true) {
      // Show first name label and input after delay (simulating onDone)
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 2500); // Matches Typewriter speed

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [showExperience]);
  // Speech Recognition Hook
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
  useSpeechRecognition();

  useEffect(() => {
    if (transcript !== null && transcript !== undefined && transcript !== "") {
      setExperience(transcript); // Update text editor with recognized speech
    }
  }, [transcript]);

  // Handle Microphone Start/Stop
  const handleMicClick = () => {
    if (!browserSupportsSpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }

    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript(); // Reset transcript before starting new speech
      SpeechRecognition.startListening({ continuous: true, language: flowLanguage == "English" ? "en-US" : "es-ES" });
    }
    setIsListening(!isListening);
  };

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const updateExperience = (experience, expToUpdate) => {
    if (!Array.isArray(experience) || experience.length === 0) {
        console.error("Experience array is not valid or empty.");
        return;
    }

    if (!expToUpdate || !expToUpdate.My_job_title || !expToUpdate.Where_i_worked) {
        console.error("expToUpdate is not valid.", expToUpdate);
        return;
    }

    const expToUpdateTitle = expToUpdate.My_job_title;
    const expToUpdatePlace = expToUpdate.Where_i_worked;

    console.log("Searching for:", expToUpdatePlace, expToUpdateTitle);
    console.log("Experience array:", experience);

    const expIndex = experience.findIndex(e => 
        e.Where_i_worked?.toLowerCase() === expToUpdatePlace?.toLowerCase() &&
        e.My_job_title?.toLowerCase() === expToUpdateTitle?.toLowerCase()
    );

    return expIndex;
};


  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (experience !== "") {
        let current_Exp_To_Be_Saved = {
          Where_i_worked: currentExp.message?.Where_i_worked,
          // Where_i_worked_location: $('[name="work_place"]').val(),
          My_job_title: currentExp.message?.My_job_title,
          Work_start_date: currentExp.message?.Work_start_date,
          Work_end_date: currentExp.message?.Work_end_date,
          Day_to_day_work: experience || null,
          // Review: true,
          Tags: Tags?.message || currentExp.message?.Tags,
          Skills: current_skills?.skills || currentExp.message?.Skills
        }
        dispatch(currentExperience(current_Exp_To_Be_Saved));
        
        let allExperience = exp.activities !== null && exp.activities?.length !== 0 ? exp.activities : [];

        // let expIndex = updateExperience(exp.activities, current_Exp_To_Be_Saved);

        allExperience = [...allExperience, current_Exp_To_Be_Saved];
        dispatch(extractLatestThreeExperiences(allExperience));

        // if (allExperience?.length == 0 || expIndex == -1) {
        //   allExperience.push(current_Exp_To_Be_Saved);
        //   console.log("All experince", allExperience);
        //   dispatch(extractLatestThreeExperiences(allExperience)) // dispatch(dispatchActivites(allExperience));
        // } else {
        //   allExperience[expIndex] = current_Exp_To_Be_Saved;
        //   dispatch(extractLatestThreeExperiences(allExperience))
        // }


        // save into server cache
        await saveIntoServerCache("current_experience", []);
        if (experience?.split(" ")?.length < 20) {
          setTimeout(() => {
            toast.error("In at least 20 words, breifly describe your daily activity", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        } else {
          dispatch(cleanEX());    
          if (listening) {
            SpeechRecognition.stopListening();
          }
          setIsListening(!isListening);
          localStorage.removeItem("fClicked");
          nextStep();
        }
      } else {
        setTimeout(() => {
            toast.error("A leas one job title is required", {
              position: toast.POSITION.TOP_RIGHT,
            });
        }, 50);
      }
    } catch (error) {
        throw error
    }
  }


  const generateExperience = () => {
    dispatch(cleanEX());
    if (listening) {
      SpeechRecognition.stopListening();
    }
    setIsListening(!isListening);
    if (currentExp.message?.Where_i_worked !== "") {
        if (Array.isArray(experience)) {
          setTruty(true);
          const cred = {
            Experience: experience,
            Language: flowLanguage || "English", // Language,
            CvType: currentExp.message?.My_job_title,
            workPlace: currentExp.message?.Where_i_worked
          }
          let count = localStorage.getItem("count") !== null ? parseInt(JSON.parse(localStorage.getItem("count")), 10) : 0;
          localStorage.setItem("count", count + 1);
          dispatch(generate_experience(cred));
          // dispatch(Deepseek_generate_experience(cred));
        } else if (typeof experience === "string") {
          if (currentExp.message?.My_job_title === "") {
            setTimeout(() => {
              toast.error("Please enter the experience job title", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          } else if (experience?.split(" ")?.length < 20) {
            setTimeout(() => {
              toast.error("In at least 20 words, breifly describe your daily activity", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          } else if ((experience !== "" && experience?.split(" ")?.length >= 20) && currentExp.message?.Where_i_worked !== "") {
            setTruty(true);
            const cred = {
              Experience: experience,
              Language: flowLanguage || "English", // Language,
              CvType: currentExp.message?.My_job_title,
              workPlace: currentExp.message?.Where_i_worked
            }
            let count = localStorage.getItem("count") !== null ? parseInt(JSON.parse(localStorage.getItem("count")), 10) : 0;
            localStorage.setItem("count", 1);
            dispatch(generate_experience(cred));
            // dispatch(Deepseek_generate_experience(cred));
            setLoading(true);
          } else {
            return false;
          }
        }
      // }
    }
    return;
  }

  const handleGenerateExperience = async () => {
    try {
      generateExperience();
    } catch (error) {
      console.log("Error while trying to generate experience", error);
    }
  }

  const handleTextBoxChange = (value) => {
    if (experience !== null && localStorage.getItem("fClicked") !== null) {
      if (eventCount >= 2) {
        setPrevGenerate(true);
      } else {
        setPrevGenerate(false);
      }
      setEventCount(e => e + 1);
    }
    setExperience(value);
  }

  return (
    <>
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 h-max py-10 px-6 md:px-8 md:py-8  bg-white flex flex-col  rounded-lg shadow-md`}>

        <div className='flex justify-center w-full'>
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <Tab num="2" current={true} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <div
          className='flex justify-center w-full'
        >
          <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
            <p className="text-center text-black font-medium notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["En tus propias palabras, cuéntanos sobre tus responsabilidades y logros en este puesto."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["In your own words, tell us about your responsibilities and achievements in this role?"]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["In your own words, tell us about your responsibilities and achievements in this role?"]} loop={1} typeSpeed={40} /><br/> */}
            </p>
            {showExperience && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
                className='flex w-full flex-col lg:flex-row gap-8 justify-between'
              >
                <div className=" w-full relative">
                  <label htmlFor="jobTitle" className="text-sm text-black mb-2 notranslate">
                    {flowLanguage == "Spanish" ? (
                      <Typewriter key={flowLanguage} words={["Cuando termines, haz clic en 'Generar' y nuestra IA completará tu experiencia laboral. Haz clic en el micrófono para hablar en lugar de escribir."]} loop={1} typeSpeed={40} />
                    ) : (
                      <Typewriter key={flowLanguage} words={["When finished, click 'Generate' and our AI will create your work Experience. Click on the microphone to speak instead.?"]} loop={1} typeSpeed={40} />
                    )}
                    {/* When finished, click 'Generate' and our AI will create your work Experience. Click on the microphone to speak instead.? */}
                  </label>
                  <div className=" w-full relative">
                    <TextEditor
                      key={flowLanguage}
                      onCut={(e) => e.preventDefault()}
                      onCopy={(e) => e.preventDefault()}
                      // onKeyDown={handleKeyDown}
                      className="h-56 w-full xl:w-full 2xl:w-full rounded-lg border border-radius border-indigo-400 border-opacity-30 focus:outline-none focus:border-2 focus:border-indigo-400 placeholder:text-[#B3B3B3] text-4xl font-normal notranslate"
                      style={{ resize: "none" }}
                      placeholder={flowLanguage == "Spanish" ? (
                        "Comienza a escribir o usa el micrófono."
                      ) : (
                        "Start typing or use the microphone"
                      )}
                      value={experience}
                      type="text"
                      id="experience"
                      name="experience"
                      onChange={(value) => handleTextBoxChange(value)}
                      required
                      notranslate
                    />
                    {/* {error && <p className='text-xs text-[#FF6633] font-medium'>{error}</p>} */}
                    {/* Microphone Button */}
                    <motion.button
                      onClick={handleMicClick}
                      className={`absolute top-[8%] right-7 p-1 rounded-full shadow-lg transition duration-300 
                        ${listening ? "bg-red-500 hover:bg-red-600" : "bg-purple-500 hover:bg-purple-600"}`}
                      animate={{
                        scale: [1, 1.3, 1],
                        y: [0, -15, 0],
                        // rotate: [0, 40, -40, 0],
                        filter: [
                          "drop-shadow(0px 0px 0px rgba(255,255,255,0))",
                          "drop-shadow(0px 0px 15px rgba(255,255,255,1))",
                          "drop-shadow(0px 0px 0px rgba(255,255,255,0))"
                        ],
                      }}
                      transition={{
                        duration: 0.5,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      <MicIcon className="text-white text-xxl" />
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center w-full">
            {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
                className="lg:flex lg:justify-between lg:max-w-[90%] w-full">
                {generatePrev == true ? 
                <button
                  className="bg-gradient-to-r from-[#FF6633] to-[#5843BD] text-white font-medium py-3 md:px-[20px] vsm:px-4 rounded-[50px] shadow-md hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300 flex items-center justify-center md:text-xl md:py-4 vsm:py-2 md:px-4 vsm:px-4 vsm:w-full vsm:my-4 md:max-w-[300px]"
                  onClick={handleGenerateExperience}
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GENERAR"
                    ) : (
                      "GENERATE"
                    )} 
                  </span> 
                  <span className="ml-2">
                    <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png" alt="Moil white logo" />
                  </span>
                </button> : 
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex justify-center items-center gap-x-3 text-black font-medium md:py-4 vsm:py-2 md:px-4 vsm:px-4 rounded-md vsm:w-full vsm:my-4 md:max-w-[300px] "
                  >
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span> 
                </button>}
  
                {generate == false ? 
                  <button
                  className="bg-gradient-to-r from-[#FF6633] to-[#5843BD] text-white font-medium py-3 md:px-[20px] vsm:px-4 rounded-[50px] shadow-md hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300 flex items-center justify-center md:text-xl md:py-4 vsm:py-2 md:px-4 vsm:px-4 vsm:w-full vsm:my-4 md:max-w-[300px]"
                  onClick={handleGenerateExperience}
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GENERAR"
                    ) : (
                      "GENERATE"
                    )} 
                  </span> 
                  <span className="ml-2">
                    <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png" alt="Moil white logo" />
                  </span>
                </button> :
                <button
                    onClick={handleNextCall}
                    className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md vsm:w-full md:py-4 vsm:py-2 md:px-4 vsm:px-4 vsm:w-full vsm:my-4 md:max-w-[300px] justify-center" 
                >
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "GUARDAR"
                        ) : (
                          "SAVE"
                        )}
                      </span>
                    
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                }
  
            </motion.div>
            )}
          </div>
          <ToastContainer />
      </div>
    </div>
    { loading && <LoaderModal text="Our AI tool is generating a standard experience description for you. Kindly wait a minute..." /> }
    </>
  );
}